import React from "react";
import { Button } from "@material-ui/core";

import colors, { colorsV2 } from "../../styles/colors";

const style = {
  wrap: {
    margin: 20,
    borderRadius: 7,
    display: "block",
  },
  button: {
    width: 300,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: "#fff",
    display: "block",
  },
  label: {
    fontSize: 20,
    textTransform: "none",
    color: colorsV2.silverChalice,
  },
};
export default ({ buttonWidth, isMobile, ...props }) => {
  //const btnColor = colorsV2.l;

  let buttonStyle = {
    width: 300,
    height: 50,
    margin: 20,
    borderRadius: 7,
    borderWidth: 1,
    //borderColor: "#fff",
    // backgroundColor: btnColor,
    display: "block",
  };
  if (buttonWidth) {
    buttonStyle = { ...buttonStyle, ...{ width: buttonWidth } };
  }

  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    buttonStyle = {
      width: "100%",
      borderRadius: 7,
      borderWidth: 1,
      // borderColor: "#fff",
    };
  }
  return (
    <Button
      style={{ ...buttonStyle, ...style.label }}
      {...props}
      variant="outlined"
    >
      {props.label}
    </Button>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/NormalBigButton.js